<template>
    <div class="row">
      <div style="height: 10px;"></div>
      <div class="col-md-12">
        <div id="contentImage"></div>
      </div>  
    </div>
</template>

<script>
    import 'cropperjs/dist/cropper.css'
    import Cropper from 'cropperjs'
    export default {
      name: 'ImageCropper',
      data () {
        return {
          cropper: {},
          croppable: false
        }
      },
      methods: {
        render (src) {
          const contentImage = document.getElementById('contentImage')
          contentImage.innerHTML = ''
          const img = new Image()
          img.onload = () => {
            this.cropper = new Cropper(img, {
              aspectRatio: 1,
              zoomOnWheel: false,
              viewMode: 1,
              ready: () => {
                this.croppable = true
              }
            })
          }
          img.src = src
          contentImage.appendChild(img)
        },
        getCanvas (sourceCanvas) {
          let canvas = document.createElement('canvas')
          let context = canvas.getContext('2d')
          let width = sourceCanvas.width
          let height = sourceCanvas.height

          canvas.width = width
          canvas.height = height
          context.imageSmoothingEnabled = true
          context.drawImage(sourceCanvas, 0, 0, width, height)
          context.beginPath()
          // context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true)
          context.fill()

          return canvas
        },
        cropImage () {
          if (!this.croppable) {
            return
          }

          // Crop
          let croppedCanvas = this.cropper.getCroppedCanvas()
          let canvas = this.getCanvas(croppedCanvas)

          canvas.toBlob(blob => {
            const data = {
              file: new File([blob], 'profile_image.jpg', { type: blob.type, lastModified: Date.now() }),
              url: URL.createObjectURL(blob)
            }

            this.setImage(data)
          }, 'image/jpeg', 1) // 1 - Full Quality
        },
        setImage (data) {
          this.$emit('setImage', data)
        }
      }
    }
</script>

<style>
    #contentImage {
      width: 100%;
      height: auto;
    }
    .cropper-view-box,
    .cropper-face {
      border-radius: 50%;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/ImageCropper.vue